module.exports = __webpack_public_path__ + "img/step9.0f0eb63d.png";